import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { UseMutationResult } from 'react-query';
import { useGetCrmAccessControlApi } from './use-get-crm-access-control-api';

const endpoint = 'ums/v1/crm/management/accesses';

export interface RevokeAccessControlResponse {
  message: string;
  success: boolean;
}

type TData = RevokeAccessControlResponse;
type TError = AxiosError;
type TVariables = number;
type Options = any;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useRevokeAccessControlApi(options?: Options): ReturnType {
  const { refetch: refetchAccessControl } = useGetCrmAccessControlApi({ enabled: false });
  const toast = useCustomToast();

  const mutationFn = async (userId: TVariables) => {
    try {
      const { data } = await http.delete(`${endpoint}/${userId}`);

      // Refetch access control list
      refetchAccessControl();

      toast({
        description: 'Access control revoked successfully',
        status: 'success',
      });

      return data;
    } catch (error: any) {
      if (!error.response?.status || !error.response?.data?.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useMutationWrapper(mutationFn, { mutationKey: endpoint, ...options });
}
